import { useEffect } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useTaxYear } from '../hooks/useTaxYear';
import { Calendar } from 'lucide-react';

export function TaxYearSelector() {
  const {
    selectedYear,
    availableYears,
    setSelectedYear,
    defaultYear,
    isLoading,
  } = useTaxYear();

  const valueInList =
    selectedYear != null && availableYears.includes(selectedYear);
  const displayValue = valueInList
    ? selectedYear
    : (defaultYear ?? availableYears[0] ?? null);

  useEffect(() => {
    if (!isLoading && !valueInList && displayValue != null) {
      setSelectedYear(displayValue);
    }
  }, [isLoading, valueInList, displayValue, setSelectedYear]);

  if (isLoading || displayValue == null || availableYears.length === 0) {
    return (
      <div className="flex items-center gap-2 px-3 py-1.5 rounded-md bg-muted/60 text-muted-foreground text-sm min-w-[100px]">
        <Calendar className="h-4 w-4 shrink-0" />
        <span>Year...</span>
      </div>
    );
  }

  return (
    <Select
      key={displayValue}
      value={String(displayValue)}
      onValueChange={(v) => setSelectedYear(Number(v))}
    >
      <SelectTrigger
        className="w-[110px] h-9 gap-1.5 border-border bg-white text-foreground"
        aria-label="Select tax year"
      >
        <Calendar className="h-4 w-4 shrink-0 text-muted-foreground" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {availableYears.map((year) => (
          <SelectItem key={year} value={String(year)}>
            {year}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
